import { render } from "./TracksScreen.vue?vue&type=template&id=23c28b31"
import script from "./TracksScreen.vue?vue&type=script&lang=js"
export * from "./TracksScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__